import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import { graphql } from 'react-apollo';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import FormControl from 'react-bootstrap/FormControl';
import cx from 'classnames';
import Link from '../Link/Link';

import messages from '../../locale/messages';
import getAllHomePageCategorySettings from '../../routes/site-admin/categorySettings/getAllHomePageCategorySettings.graphql';
import deleteTopFeature from '../../actions/siteadmin/TopFeature/deleteTopFeature';
import Loader from '../../components/Common/Loader';
import withStyles from 'isomorphic-style-loader/withStyles';
import updateTopFeatureStatus from '../../actions/siteadmin/TopFeature/updateTopFeatureStatus';

import EditIcon from '/public/Icons/editIcon.svg';
import TrashIcon from '/public/Icons/deleteIcon.svg';
import debounce from '../../helpers/debounce';
import s from './TopFeatureList.css';
import bt from '../../components/commonStyle.css';
import CustomPagination from '../CustomPagination/CustomPagination';

class TopFeatureList extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            currentPage: 1,
            searchList: '',
        }
    }

    handleDelete = async (id, currentPage) => {
        const { deleteTopFeature, getAllHomePageCategorySettings: { refetch } } = this.props;
        let variables = { currentPage };
        await deleteTopFeature(id);
        refetch(variables);
    }

    handleKeywordSearch = debounce((searchList) => {
        const { getAllHomePageCategorySettings: { refetch } } = this.props;
        let variables = {
            currentPage: 1,
            searchList: searchList
        }

        this.setState({ searchList, currentPage: 1 });
        refetch(variables);
    });

    paginationData = (currentPage) => {
        const { getAllHomePageCategorySettings: { refetch } } = this.props;
        let variables = { currentPage };
        this.setState({ currentPage });
        refetch(variables);
    }

    handleStatus = async (id, isActive, currentPage) => {
        const { updateTopFeatureStatus, getAllHomePageCategorySettings: { refetch } } = this.props;
        let variables = { currentPage };
        await updateTopFeatureStatus(id, isActive);
        refetch(variables);
    }

    render() {
        const { formatMessage } = this.props.intl;
        const { getAllHomePageCategorySettings, loading } = this.props;
        const { currentPage } = this.state;

        return (
            <div className={cx(s.widthInner, 'whiteDropdown')}>
                <div className={cx(s.exportDisplay, s.searchInputSection)}>
                    <div className={s.searchInput}>
                        <FormControl type='text' placeholder={formatMessage(messages.searchOnly)} onChange={(event) => this.handleKeywordSearch(event.target && event.target.value)} className={bt.formControlInput} />
                    </div>
                    <Link to={`/siteadmin/homepage/top-feature/add`} className={cx(bt.btnPrimary)} >{formatMessage(messages.addNewLabel)}</Link>
                </div>
                <div class="clearfix"></div>
                {
                    loading && <div>
                        <Loader type="circle" />
                    </div>
                }
                {!loading &&
                    <div className={cx(s.tableCss, 'tableCss', 'tableSticky', 'newAdminResponsiveTable', 'NewResponsiveTable')}>
                        <Table className="table">
                            <thead>
                                <tr>
                                    <th scope="col"><FormattedMessage {...messages.id} /></th>
                                    <th scope="col"><FormattedMessage {...messages.name} /></th>
                                    <th scope="col"><FormattedMessage {...messages.status} /></th>
                                    <th scope="col"><FormattedMessage {...messages.action} /></th>
                                    <th scope="col"><FormattedMessage {...messages.deleteAction} /></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    getAllHomePageCategorySettings?.getAllHomePageCategorySettings?.results?.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td data-label={formatMessage(messages.id)}>{item?.id}</td>
                                                <td data-label={formatMessage(messages.name)}>{item?.title}</td>
                                                <td data-label={formatMessage(messages.status)}>
                                                    <select className={bt.selectInput} value={item?.isActive} onChange={(e) => { this.handleStatus(item?.id, e?.target?.value, currentPage) }}>
                                                        <option value={1}>{formatMessage(messages.active)}</option>
                                                        <option value={0}>{formatMessage(messages.inactive)}</option>
                                                    </select>
                                                </td>
                                                <td data-label={formatMessage(messages.action)}>
                                                    <Link to={'/siteadmin/homepage/top-feature/edit/' + item.id} className={cx('editAlign', s.noLink, 'darkLink')}>
                                                        <span className={'svgImg'}><img src={EditIcon} className={cx(s.editIcon, 'editIconRTL')} /></span>
                                                        <span className={cx(s.vtrMiddle, s.top)}>
                                                            <FormattedMessage {...messages.editAction} />
                                                        </span>
                                                    </Link>
                                                </td>
                                                <td data-label={formatMessage(messages.deleteAction)}>
                                                    <Button onClick={() => this.handleDelete(item.id, currentPage)} className={cx(s.iconBtn, 'svgImg', 'darkLink')}>
                                                        <img src={TrashIcon} className={cx(s.editIcon, 'editIconRTL')} />
                                                        <span className={s.vtrMiddle}><FormattedMessage {...messages.deleteAction} /></span>
                                                    </Button>
                                                </td>
                                            </tr>
                                        )
                                    })}
                            </tbody>
                            {
                                !loading && getAllHomePageCategorySettings?.getAllHomePageCategorySettings?.results.length == 0 && (
                                    <tr>
                                        <td colspan="12" ><FormattedMessage {...messages.noResult} /></td>
                                    </tr>
                                )
                            }
                        </Table>
                    </div>
                }
                {
                    getAllHomePageCategorySettings?.getAllHomePageCategorySettings?.results?.length > 0
                    && <div >
                        <CustomPagination
                            total={getAllHomePageCategorySettings?.getAllHomePageCategorySettings?.count}
                            currentPage={currentPage}
                            defaultCurrent={1}
                            defaultPageSize={10}
                            change={this.paginationData}
                            paginationLabel={formatMessage(messages.categorieslist)}
                        />
                    </div>
                }
            </div>
        )
    }
}

const mapDispatch = {
    deleteTopFeature,
    updateTopFeatureStatus
};
const mapState = (state) => ({
    loading: state?.intl?.loading
});

export default injectIntl(compose(
    withStyles(s, bt),
    graphql(getAllHomePageCategorySettings, {
        name: 'getAllHomePageCategorySettings',
        options: {
            variables: {
                currentPage: 1,
                searchList: ''
            },
            fetchPolicy: 'network-only',
            ssr: false
        }
    }),
    connect(mapState, mapDispatch)
)(TopFeatureList))